import React, { useEffect, useState } from "react";
import CustomButton from "../../components/common/controls/CustomButton";
import { constants } from "../../constants/constants";
import { Button } from "@material-ui/core";
import { convertToCSV, formatDdData } from "../../utilities/csvDownloadUtils";

export default function DownloadCSV({
  label = constants.exportData,
  data = [],
  fileName = "download.csv",
}) {
  const [jsonData, setJsonData] = useState([]);

  useEffect(() => {
    setJsonData(data || []);
  }, [data]);

  const handleDownload = () => {
    try {
      const csvContent = convertToCSV(formatDdData(jsonData));

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating CSV file:", error);
    }
  };

  return (
    <div>
      <CustomButton
        id="download-csv"
        showGradient={true}
        variant="contained"
        Add
        commentMore
        actions
        color="primary"
        disabled={false}
        name={label}
        onClick={handleDownload}
      />
    </div>
  );
}
